import React, { useState } from 'react';
import styled from 'styled-components';
import useRestPassword from './useRestPassword';
import {
  CANCEL,
  RESET_PASSWORD,
  RESET_PASSWORD_CONFIRMATION_STRING,
  SEND,
  SEND_RESET_PASSWORD_LINK,
} from '../../utils/constants';
import { ConfirmModal } from '../../utils/ConfirmModal';
import { LinkButton } from '../Buttons';
import { isValidEmailDomain } from '../../utils/Validators';

interface Props {
  email: string;
}

const StyledButton = styled(LinkButton)`
  margin-top: 8px;
  align-self: flex-end;
`;

const ResetPassword = ({ email }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { resetPassword } = useRestPassword();

  const handleRestPassword = () => {
    resetPassword(email);
    setIsOpen(false);
  };

  const showConfirmationDialog = () => setIsOpen(true);
  const isValidEmail = isValidEmailDomain(email);

  if (!isValidEmail) {
    return <React.Fragment />;
  }

  return (
    <React.Fragment>
      <StyledButton
        onClick={showConfirmationDialog}
        data-testid="btn-reset-password"
      >
        {SEND_RESET_PASSWORD_LINK}
      </StyledButton>

      <ConfirmModal
        open={isOpen}
        heading={RESET_PASSWORD}
        message={RESET_PASSWORD_CONFIRMATION_STRING.replace(':email', email)}
        modalVisibility={setIsOpen}
        onYesClick={handleRestPassword}
        yesButtonText={SEND}
        noButtonText={CANCEL}
      />
    </React.Fragment>
  );
};

export default ResetPassword;
